import React from 'react';
import Layout from '../Components/Layout/Layout';
import AllPosts from '../Components/ViewMoreAllPosts/AllPosts';

function ViewMore() {
  return (
    <Layout>
      <AllPosts />
    </Layout>
  );
}

export default ViewMore;
